import { render, staticRenderFns } from "./LandingWeserve.vue?vue&type=template&id=652cc7da"
import script from "./LandingWeserve.vue?vue&type=script&lang=js"
export * from "./LandingWeserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports